/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RawTableItemRequest = {
    description: `Table Item request for the GetTableItemRaw API`,
    properties: {
        key: {
            type: 'HexEncodedBytes',
            isRequired: true,
        },
    },
} as const;
